import { useEffect } from "react";

import useUserRole from "@/hooks/use-user-role";

import { useMaskDialog } from "./use-mask-dialog";

/**
 * Mask-dialog state gated to admins: while the role is loading the dialog
 * stays closed, and a non-admin landing on the action URL has it stripped
 * (the opener appears dead instead of flashing a forbidden dialog).
 */
export function useAdminOnlyDialog(action: string): {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
} {
  const { isAdmin, isLoading } = useUserRole();
  const { isOpen, onOpenChange, close } = useMaskDialog(action);

  useEffect(() => {
    if (isLoading) return;
    if (isOpen && !isAdmin) close();
  }, [isLoading, isOpen, isAdmin, close]);

  return { isOpen: isOpen && isAdmin, onOpenChange };
}
